(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dynamic-delivery-estimate"] && !Shopify.designMode) return;
  try {
    (() => {
    const TIME_ZONE = 'Europe/Bucharest';

    const FIXED_HOLIDAYS = [
      '01-01', '01-02', '01-06', '01-07', '01-24',
      '05-01', '06-01', '08-15', '11-30', '12-01',
      '12-25', '12-26'
    ];

    // Pentru zile proprii fără expediere (inventar, concediu etc.), adaugă date YYYY-MM-DD.
    const EXTRA_CLOSED_DATES = [];

    const bucharestFormatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: TIME_ZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    });

    const roDateFormatter = new Intl.DateTimeFormat('ro-RO', {
      timeZone: 'UTC',
      weekday: 'long',
      day: 'numeric',
      month: 'long'
    });

    function getBucharestParts(date) {
      const parts = {};
      bucharestFormatter.formatToParts(date).forEach((part) => {
        if (part.type !== 'literal') parts[part.type] = Number(part.value);
      });
      return {
        year: parts.year,
        month: parts.month,
        day: parts.day,
        hour: parts.hour,
        minute: parts.minute,
        second: parts.second
      };
    }

    function dateKey(date) {
      return `${date.year}-${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`;
    }

    function monthDayKey(date) {
      return `${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`;
    }

    function addCalendarDays(date, days) {
      const value = new Date(Date.UTC(date.year, date.month - 1, date.day + days));
      return {
        year: value.getUTCFullYear(),
        month: value.getUTCMonth() + 1,
        day: value.getUTCDate()
      };
    }

    function weekday(date) {
      return new Date(Date.UTC(date.year, date.month - 1, date.day)).getUTCDay();
    }

    function orthodoxEaster(year) {
      const a = year % 4;
      const b = year % 7;
      const c = year % 19;
      const d = (19 * c + 15) % 30;
      const e = (2 * a + 4 * b - d + 34) % 7;
      const julianMonth = Math.floor((d + e + 114) / 31);
      const julianDay = ((d + e + 114) % 31) + 1;
      const julianDate = new Date(Date.UTC(year, julianMonth - 1, julianDay + 13));

      return {
        year: julianDate.getUTCFullYear(),
        month: julianDate.getUTCMonth() + 1,
        day: julianDate.getUTCDate()
      };
    }

    function movableHolidayKeys(year) {
      const easter = orthodoxEaster(year);
      return new Set([
        dateKey(addCalendarDays(easter, -2)),
        dateKey(easter),
        dateKey(addCalendarDays(easter, 1)),
        dateKey(addCalendarDays(easter, 49)),
        dateKey(addCalendarDays(easter, 50))
      ]);
    }

    function isWorkingDay(date) {
      const day = weekday(date);
      if (day === 0 || day === 6) return false;
      if (FIXED_HOLIDAYS.includes(monthDayKey(date))) return false;
      if (EXTRA_CLOSED_DATES.includes(dateKey(date))) return false;
      if (movableHolidayKeys(date.year).has(dateKey(date))) return false;
      return true;
    }

    function nextWorkingDay(date) {
      let candidate = addCalendarDays(date, 1);
      while (!isWorkingDay(candidate)) candidate = addCalendarDays(candidate, 1);
      return candidate;
    }

    function addWorkingDays(date, numberOfDays) {
      let candidate = date;
      let remaining = numberOfDays;
      while (remaining > 0) {
        candidate = addCalendarDays(candidate, 1);
        if (isWorkingDay(candidate)) remaining -= 1;
      }
      return candidate;
    }

    function formatDate(date) {
      return roDateFormatter.format(new Date(Date.UTC(date.year, date.month - 1, date.day)));
    }

    class KsDeliveryEstimate extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        const cutoffHour = Number(this.dataset.cutoffHour || 14);
        const minDays = Number(this.dataset.deliveryMinDays || 1);
        const maxDays = Number(this.dataset.deliveryMaxDays || 2);
        const now = getBucharestParts(new Date());
        const today = { year: now.year, month: now.month, day: now.day };
        const shipsToday = isWorkingDay(today) && now.hour < cutoffHour;
        const dispatchDate = shipsToday ? today : nextWorkingDay(today);
        const earliestDelivery = addWorkingDays(dispatchDate, minDays);
        const latestDelivery = addWorkingDays(dispatchDate, maxDays);
        const dispatchMessage = this.querySelector('[data-dispatch-message]');
        const deliveryMessage = this.querySelector('[data-delivery-message]');

        if (shipsToday) {
          dispatchMessage.textContent = `Comandă până la ora ${String(cutoffHour).padStart(2, '0')}:00 și expediem astăzi.`;
        } else {
          dispatchMessage.textContent = `Expediere estimată: ${formatDate(dispatchDate)}.`;
        }

        deliveryMessage.textContent = `Livrare estimată: ${formatDate(earliestDelivery)} – ${formatDate(latestDelivery)}.`;
      }
    }

    if (!customElements.get('ks-delivery-estimate')) {
      customElements.define('ks-delivery-estimate', KsDeliveryEstimate);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ks-bracelet-size-guide"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-ks-bracelet-size-guide]').forEach((guide) => {
      if (guide.dataset.initialized === 'true') return;

      const product = guide.closest('.m-main-product');
      const picker = product?.querySelector('variant-picker');
      const error = guide.querySelector('[data-ks-bracelet-size-error]');

      if (!product || !picker || !error) return;

      const label = picker.querySelector('.option-label--title');
      if (label) label.textContent = guide.dataset.chooseLabel;

      let selectionMade = new URLSearchParams(window.location.search).has('variant');

      const clearError = () => {
        error.hidden = true;
        picker.classList.remove('ks-bracelet-size-required');
      };

      product.addEventListener('change', (event) => {
        const target = event.target;
        const isMainPicker = target.closest('variant-picker') === picker;
        const isStickyPicker = target.matches('.m-sticky-addtocart [name="id"]');

        if (!isMainPicker && !isStickyPicker) return;

        selectionMade = true;
        window.requestAnimationFrame(clearError);
      });

      product.querySelectorAll('form[data-type="add-to-cart-form"]').forEach((form) => {
        form.addEventListener('submit', (event) => {
          const variantId = form.querySelector('[name="id"]')?.value;
          if (selectionMade && variantId) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          error.hidden = false;
          picker.classList.add('ks-bracelet-size-required');
          picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, true);
      });

      guide.dataset.initialized = 'true';
    });
  };

  initialize();

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ks-delivery-estimate"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('ks-delivery-estimate')) return;

    class KsDeliveryEstimate extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.timeZone = this.dataset.timeZone || 'Europe/Bucharest';
        this.locale = this.dataset.locale || 'ro-RO';
        this.cutoffHour = Number(this.dataset.cutoffHour || 14);
        this.rangeNode = this.querySelector('[data-ks-delivery-range]');
        this.promptNode = this.querySelector('[data-ks-delivery-prompt]');
        this.openButton = this.querySelector('[data-ks-delivery-open]');
        this.dialog = this.querySelector('[data-ks-delivery-dialog]');
        this.closeButton = this.querySelector('[data-ks-delivery-close]');
        this.partsFormatter = new Intl.DateTimeFormat('en-GB', {
          timeZone: this.timeZone,
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hourCycle: 'h23'
        });
        this.dateFormatter = new Intl.DateTimeFormat(this.locale, {
          timeZone: 'UTC',
          weekday: 'long',
          day: 'numeric',
          month: 'long'
        });
        this.handleOpen = () => this.openDialog();
        this.handleDialogClick = (event) => {
          if (event.target === this.dialog) this.dialog.close();
        };
        this.handleDialogClose = () => this.openButton?.focus();
        this.openButton?.addEventListener('click', this.handleOpen);
        this.dialog?.addEventListener('click', this.handleDialogClick);
        this.dialog?.addEventListener('close', this.handleDialogClose);
        this.renderEstimate();
        this.timer = window.setInterval(() => this.renderEstimate(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
        this.openButton?.removeEventListener('click', this.handleOpen);
        this.dialog?.removeEventListener('click', this.handleDialogClick);
        this.dialog?.removeEventListener('close', this.handleDialogClose);
        this.initialized = false;
      }

      getZonedParts(date) {
        return this.partsFormatter.formatToParts(date).reduce((parts, part) => {
          if (part.type !== 'literal') parts[part.type] = Number(part.value);
          return parts;
        }, {});
      }

      getCalendarDate(year, month, day) {
        return new Date(Date.UTC(year, month - 1, day));
      }

      isBusinessDay(date) {
        const weekday = date.getUTCDay();
        return weekday !== 0 && weekday !== 6;
      }

      nextBusinessDay(date) {
        const result = new Date(date);
        do {
          result.setUTCDate(result.getUTCDate() + 1);
        } while (!this.isBusinessDay(result));
        return result;
      }

      addBusinessDays(date, days) {
        const result = new Date(date);
        let remaining = days;
        while (remaining > 0) {
          result.setUTCDate(result.getUTCDate() + 1);
          if (this.isBusinessDay(result)) remaining -= 1;
        }
        return result;
      }

      formatRemainingTime(totalSeconds) {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const hourLabel = hours === 1 ? this.dataset.hourOne : this.dataset.hoursMany;
        const minuteLabel = minutes === 1 ? this.dataset.minuteOne : this.dataset.minutesMany;

        if (hours > 0 && minutes > 0) {
          return `${hours} ${hourLabel} ${this.dataset.timeAnd} ${minutes} ${minuteLabel}`;
        }
        if (hours > 0) return `${hours} ${hourLabel}`;
        if (minutes > 0) return `${minutes} ${minuteLabel}`;
        return this.dataset.lessThanMinute;
      }

      renderEstimate() {
        if (!this.rangeNode || !this.promptNode) return;
        const now = new Date();
        const local = this.getZonedParts(now);
        const today = this.getCalendarDate(local.year, local.month, local.day);
        const cutoffSeconds = this.cutoffHour * 3600;
        const currentSeconds = local.hour * 3600 + local.minute * 60 + local.second;
        const processesToday = this.isBusinessDay(today) && currentSeconds < cutoffSeconds;
        const processingDate = processesToday ? today : this.nextBusinessDay(today);
        const deliveryStart = this.addBusinessDays(processingDate, 1);
        const deliveryEnd = this.addBusinessDays(processingDate, 2);

        this.rangeNode.textContent = `${this.dateFormatter.format(deliveryStart)} – ${this.dateFormatter.format(deliveryEnd)}`;

        if (processesToday) {
          const remainingTime = this.formatRemainingTime(Math.max(0, cutoffSeconds - currentSeconds));
          this.promptNode.textContent = this.dataset.countdownTemplate.replace('__TIME__', remainingTime);
          this.promptNode.hidden = false;
        } else {
          this.promptNode.hidden = true;
          this.promptNode.textContent = '';
        }
      }

      openDialog() {
        if (!this.dialog || this.dialog.open) return;
        this.dialog.showModal();
        window.requestAnimationFrame(() => this.closeButton?.focus());
      }
    }

    customElements.define('ks-delivery-estimate', KsDeliveryEstimate);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ks-knee-purchase"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('ks-knee-purchase')) return;
  class KneePurchase extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const configNode = this.querySelector('[data-ks-config]');
      if (!configNode) return;
      this.initialized = true;
      this.config = JSON.parse(configNode.textContent);
      this.text = this.config.text;
      this.form = this.querySelector('form');
      this.first = this.querySelector('[data-ks-first]');
      this.second = this.querySelector('[data-ks-second]');
      this.addButton = this.querySelector('[data-ks-add]');
      this.error = this.querySelector('.ks-knee-error');
      this.sticky = document.getElementById('ks-knee-sticky');
      this.stickyButton = this.sticky?.querySelector('button');
      this.busy = false;
      this.format = new Intl.NumberFormat('ro-RO', {style:'currency',currency:this.config.currency,currencyDisplay:'narrowSymbol'});
      this.addEventListener('change', () => { this.error.hidden = true; this.sync(); });
      this.form.addEventListener('submit', (event) => { event.preventDefault(); this.add(); });
      this.stickyButton?.addEventListener('click', () => {
        if (!this.selection().valid) { this.reveal(); return; }
        this.add();
      });
      const reviews = document.querySelector('.ks-knee-reviews');
      if (reviews) reviews.id = 'ks-knee-reviews';
      document.body.classList.add('ks-knee-page');
      this.sync();
      if (this.sticky) {
        this.observer = new IntersectionObserver(entries => {
          this.sticky.hidden = entries[0].isIntersecting;
        }, {threshold:0.3});
        this.observer.observe(this.addButton);
      }
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    selection() {
      const duo = this.querySelector('input[name="ks_offer"]:checked')?.value === 'duo';
      const first = this.config.variants.find(v => String(v.id) === this.first.value);
      const second = this.config.variants.find(v => String(v.id) === this.second.value);
      const bundle = duo && first && second ? this.config.bundles.find(v => v.first === first.size && v.second === second.size) : null;
      const complete = !!first && (!duo || !!second);
      const available = duo ? !!(this.config.bundleAvailable && bundle?.available && first?.available && second?.available) : !!first?.available;
      return {duo,first,second,bundle,complete,available,valid:complete && available,price:duo ? (bundle?.price ?? this.config.duoPrice) : (first?.price ?? this.config.singlePrice)};
    }
    sync() {
      const state = this.selection();
      this.querySelector('[data-ks-second-wrap]').hidden = !state.duo;
      this.second.disabled = !state.duo || this.busy;
      this.first.disabled = this.busy;
      this.querySelectorAll('input[name="ks_offer"]').forEach(radio => {radio.disabled = this.busy || (radio.value === 'duo' && !this.config.bundleAvailable);});
      this.querySelector('[data-ks-gift]').hidden = !state.duo;
      this.querySelector('[data-ks-first-label]').textContent = state.duo ? this.text.firstSize : this.text.singleSize;
      this.querySelector('[data-ks-pack-note]').textContent = state.duo ? this.text.duoNote : this.text.singleNote;
      const price = this.format.format(state.price / 100);
      const offer = state.duo ? this.text.duo : this.text.single;
      const singlePrice = state.first?.price ?? this.config.singlePrice;
      const singleCompare = state.first ? state.first.compareAtPrice : this.config.singleCompareAtPrice;
      document.querySelectorAll('[data-ks-price-scope]').forEach(group => {
        const isSingle = group.dataset.ksPriceScope === 'single';
        const amount = isSingle ? singlePrice : state.price;
        const compare = isSingle || !state.duo ? singleCompare : 0;
        group.querySelector('[data-ks-knee-price]').textContent = this.format.format(amount / 100);
        const comparison = group.querySelector('[data-ks-knee-compare-wrap]');
        comparison.hidden = !(compare > amount);
        group.querySelector('[data-ks-knee-compare-value]').textContent = compare > amount ? this.format.format(compare / 100) : '';
      });
      document.querySelectorAll('[data-ks-knee-offer-label]').forEach(node => {node.textContent = offer;});
      const label = this.busy ? this.text.adding : !state.complete ? (state.duo ? this.text.chooseSizes : this.text.chooseSize) : !state.available ? this.text.unavailable : `${this.text.add} – ${price}`;
      this.addButton.textContent = label;
      this.addButton.disabled = this.busy || (state.complete && !state.available);
      this.addButton.setAttribute('aria-busy', String(this.busy));
      if (this.stickyButton) {
        this.stickyButton.textContent = this.busy ? this.text.adding : state.valid ? this.text.add : state.complete ? this.text.unavailable : state.duo ? this.text.chooseSizes : this.text.chooseSize;
        this.stickyButton.disabled = this.addButton.disabled;
        this.sticky.querySelector('[data-ks-sticky-selection]').textContent = [offer,state.first?.size,state.duo ? state.second?.size : null].filter(Boolean).join(' · ');
      }
    }
    reveal() {
      this.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'center'});
      const field = !this.first.value ? this.first : this.second;
      field.focus({preventScroll:true});
    }
    showError(message) {this.error.textContent = message;this.error.hidden = false;}
    async add() {
      if (this.busy) return;
      const state = this.selection();
      if (!state.valid) {
        this.showError(!state.first ? this.text.chooseFirst : state.duo && !state.second ? this.text.chooseSecond : this.text.combination);
        this.reveal();
        return;
      }
      this.error.hidden = true;
      this.busy = true;
      this.sync();
      const items = state.duo ? [{id:state.bundle.id,quantity:1,properties:{'_ks_oferta':'Pachet Duo Genunchiere'}},{id:this.config.giftId,quantity:1,properties:{'_ks_cadou_pentru':'Pachet Duo Genunchiere'}}] : [{id:state.first.id,quantity:1}];
      const cartDrawer = document.querySelector('m-cart-drawer');
      const body = {items};
      if (typeof cartDrawer?.getSectionsToRender === 'function') {
        body.sections = cartDrawer.getSectionsToRender().map(section => section.id);
        body.sections_url = location.pathname;
      }
      const root = window.Shopify?.routes?.root || '/';
      let accepted = false;
      try {
        let response;
        try {response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify(body)});}
        catch (_) {throw new Error(this.text.uncertain);}
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || this.text.error);
        accepted = true;
        if (window.MinimogEvents && window.MinimogTheme?.pubSubEvents) window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate,data);
        const canOpen = typeof cartDrawer?.renderContents === 'function' && window.MinimogSettings?.use_ajax_atc && window.MinimogSettings?.enable_cart_drawer;
        const openThemeCart = () => {
          if (!canOpen) {location.href = root + 'cart';return;}
          cartDrawer.renderContents(data);
          if (window.MinimogEvents && window.MinimogTheme?.pubSubEvents) window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.openCartDrawer);
        };
        if (document.getElementById('essential-cart-drawer-portal')) {
          cartDrawer?.onCartDrawerUpdate?.();
          setTimeout(() => {if (!document.documentElement.classList.contains('essential-cart__open')) openThemeCart();},900);
        } else openThemeCart();
      } catch (error) {
        if (accepted) {location.href = root + 'cart';return;}
        this.showError(error.message || this.text.error);
      } finally {
        this.busy = false;
        this.sync();
      }
    }
  }
  customElements.define('ks-knee-purchase', KneePurchase);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery-conversion"] && !Shopify.designMode) return;
  try {
    (() => {
    const hintKey = 'ksGalleryZoomHintSeen';

    const enhanceGallery = (gallery) => {
      if (gallery.dataset.galleryEnhanced === 'true') return;

      let attempts = 0;
      const connect = () => {
        attempts += 1;
        if (!gallery.slider) {
          if (attempts < 120) window.setTimeout(connect, 50);
          return;
        }

        gallery.dataset.galleryEnhanced = 'true';
        const counter = gallery.querySelector('[data-gallery-counter]');
        const slides = gallery.querySelectorAll('.m-product-media--slider__images .swiper-slide:not(.swiper-slide-duplicate)');
        const total = slides.length;

        const updateCounter = () => {
          if (!counter || total < 2) return;
          const index = Number.isInteger(gallery.slider.realIndex)
            ? gallery.slider.realIndex
            : gallery.slider.activeIndex || 0;
          counter.textContent = `${Math.min(index + 1, total)} / ${total}`;
        };

        updateCounter();
        gallery.slider.on('slideChange', updateCounter);

        if (gallery.navSlider) {
          gallery.navSlider.params.slidesPerView = 4.35;
          gallery.navSlider.update();
        }

        const hint = gallery.querySelector('[data-gallery-zoom-hint]');
        if (!hint) return;

        const hideHint = () => {
          hint.classList.add('is-hidden');
          try {
            window.sessionStorage.setItem(hintKey, 'true');
          } catch (error) {
            return;
          }
        };

        try {
          if (window.sessionStorage.getItem(hintKey) === 'true') {
            hint.classList.add('is-hidden');
            return;
          }
        } catch (error) {
          hint.classList.remove('is-hidden');
        }

        gallery.addEventListener('pointerup', hideHint, { once: true });
        window.setTimeout(hideHint, 4500);
      };

      connect();
    };

    const enhanceAll = () => {
      document.querySelectorAll('media-gallery-mobile').forEach(enhanceGallery);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', enhanceAll, { once: true });
    } else {
      enhanceAll();
    }

    document.addEventListener('shopify:section:load', enhanceAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
